import React from "react"
import data from "../../data/content.json"
import { Row, Col, Image } from "react-bootstrap"
import { connect } from "react-redux"
import "../../style/Common/common.css"
import "./Companies.css"

import arauco from "../../images/arauco.svg"
import adt from "../../images/dt.svg"
import propins from "../../images/propins.svg"
import cat from "../../images/finning.svg"
import forus from "../../images/Forus.svg"
import falabella from "../../images/Falabella.svg"
import microsoft from "../../images/microsoft.svg"
import hsbc from "../../images/hsbc.svg"
import fach from "../../images/Fach.svg"
import fosis from "../../images/FOSIS.svg"
import prochile from "../../images/prochile.svg"
import sura from "../../images/sura.svg"
import hp from "../../images/hp.svg"
import mercadoPublico from "../../images/mercadoPublico.svg"
import minsal from "../../images/MINSAL.svg"
import meetcard from "../../images/meetcard.svg"
//
import bancoChile from "../../images/bancoChile.svg"
import chileExpress from "../../images/chileexpress.svg"
import westernUnion from "../../images/WesternUnion.svg"
import whyx from "../../images/whyx.svg"
import sag from "../../images/SAG.svg"
import kaufmann from "../../images/Kaufmann.svg"
import sodimac from "../../images/Sodimac.svg"
import derco from "../../images/Derco.svg"
import santander from "../../images/santander.svg"
import wom from "../../images/wom.svg"
import cruzBlanca from "../../images/CruzBlanca.svg"
import salfa from "../../images/Salfa.svg"
import bancoBice from "../../images/bancoBice.svg"
import michelin from "../../images/michelin.svg"
import softline from "../../images/Softline.svg"
import ypf from "../../images/YPF.svg"
import softwareOne from "../../images/softwareone.svg"
import inmotion from "../../images/inMotion.svg"

class Companies extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      imageshow: "hidden",
      data,
    }
  }
  componentDidMount() {
    this.setState({ imageshow: "delay" })
  }
  render() {
    return (
      <>
        <Row
          className={`justify-content-center company ${this.props.classAnimationCompanies} ${this.props.edgeAnimation} imageSpacing`}
        >
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL ONE - ROW 1*/}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={falabella} />
              <img id="f2" alt="companyIcon" src={bancoChile} />
              <img id="f3" alt="companyIcon" src={arauco} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL TWO - ROW 1 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={microsoft} />
              <img id="f2" alt="companyIcon" src={chileExpress} />
              <img id="f3" alt="companyIcon" src={whyx} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL THREE - ROW 1 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={arauco} />
              <img id="f2" alt="companyIcon" src={meetcard} />
              <img id="f3" alt="companyIcon" src={cruzBlanca} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL FOUR - ROW 1 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={hsbc} />
              <img id="f2" alt="companyIcon" src={forus} />
              <img id="f3" alt="companyIcon" src={salfa} />
            </div>
          </Col>
        </Row>

        <Row
          className={`justify-content-center company ${this.props.classAnimationCompanies} imageSpacing`}
        >
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL ONE - ROW 2*/}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={adt} />
              <img id="f2" alt="companyIcon" src={westernUnion} />
              <img id="f3" alt="companyIcon" src={bancoBice} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL TWO - ROW 2 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={fach} />
              <img id="f2" alt="companyIcon" src={sag} />
              <img id="f3" alt="companyIcon" src={michelin} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL THREE - ROW 2 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={fosis} />
              <img id="f2" alt="companyIcon" src={kaufmann} />
              <img id="f3" alt="companyIcon" src={softline} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL FOUR - ROW 2 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={prochile} />
              <img id="f2" alt="companyIcon" src={sodimac} />
              <img id="f3" alt="companyIcon" src={ypf} />
            </div>
          </Col>
        </Row>

        <Row
          className={`justify-content-center company ${this.props.classAnimationCompanies} imageSpacing`}
        >
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL ONE  - ROW 3*/}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={sura} />
              <img id="f2" alt="companyIcon" src={derco} />
              <img id="f3" alt="companyIcon" src={cat} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL TWO - ROW 3*/}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={hp} />
              <img id="f2" alt="companyIcon" src={santander} />
              <img id="f3" alt="companyIcon" src={softwareOne} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL THREE - ROW 3 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={mercadoPublico} />
              <img id="f2" alt="companyIcon" src={wom} />
              <img id="f3" alt="companyIcon" src={inmotion} />
            </div>
          </Col>
          <Col
            xs={6}
            sm={6}
            md={5}
            lg={3}
            xl={2}
            className="align-self-center align-items-center"
          >
            {/* CAROUSEL THREE - ROW 4 */}
            <div id="fadein">
              <img id="f1" alt="companyIcon" src={minsal} />
              <img id="f2" alt="companyIcon" src={propins} />
              <img id="f3" alt="companyIcon" src={santander} />
            </div>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    changeLang: lang => dispatch({ type: "SET_LANGUAGE", payload: lang }),
  }
}

Companies = connect(mapStateToProps, mapDispatchToProps)(Companies)
export default Companies
